import { TextField, Typography, Button, Stack } from "@mui/material";
import { useState } from "react";
import PasswordImage from "assets/password.png";
import InfoIcon from "@mui/icons-material/Info";
import { useConsigazApi } from "hooks/useConsigazApi";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import ModalFindCode from "../../Login/components/LoginStepClientCode/ModalFindCode/ModalFindCode";
import LinkCnpjSuccessModal from "components/DataDisplay/LinkSuccessCnpjModal/LinkCnpjSuccessModal";
import { useAuth } from "hooks/useAuth";
import ClienteService from "services/cliente";
import CondominioService from "services/condominio";

export default function LinkCnpjClientCode({ cnpj }) {
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [openModalSuccess, setOpenModalSuccess] = useState(false);
  const [name, setName] = useState("");
  const [clientCode, setClientCode] = useState("");

  const api = useConsigazApi();
  const router = useHistory();

  const { userCpf } = useAuth();

  const handleSubmit = async () => {
    if (!clientCode.trim()) {
      return toast.error("Código de cliente é obrigatório.");
    }

    if (!userCpf) {
      return toast.error("CPF do usuário não encontrado.");
    }

    try {
      const { retorno } = await api.linkCNPJ({
        cpf: userCpf,
        cnpj: cnpj,
        clientCode: clientCode,
      });

      const { Cliente } = await api.consultaLocalEntrega(cnpj);

      if (!Cliente) {
        return toast.error("Cliente não encontrado.");
      }

      ClienteService.localEntrega = Cliente.ClienteRetorno[0];
      CondominioService.selected =
        Cliente.ClienteRetorno[0].ClienteEntrRetorno[0];

      setName(retorno[0]["razao-social"]);

      setOpenModalSuccess(true);
    } catch (error) {
      return toast.error(error);
    }
  };

  return (
    <>
      <img src={PasswordImage} />
      <Typography
        color="#FFFFFF"
        fontWeight={700}
        fontSize={"30px"}
        mt={"30px"}
      >
        Informe código de cliente
      </Typography>
      <Typography
        color="#FFFFFF"
        fontSize={"15px"}
        mt={"10px"}
        textAlign={"justify"}
      >
        Insira o código de cliente da conta industrial informada para validar o
        vinculo de seu acesso.
      </Typography>

      <TextField
        variant="standard"
        color="secondary"
        value={clientCode}
        type="number"
        fullWidth
        onChange={(e) => {
          setClientCode(e.target.value);
        }}
        placeholder={"Código do cliente"}
        sx={{
          mt: 5,
          "& input::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
          },
        }}
      />
      <Button
        variant="contained"
        color="secondary"
        sx={{
          height: "45px",
          color: "#fff",
          borderRadius: "36px",
          width: "100%",
          mt: 2,
        }}
        onClick={handleSubmit}
      >
        Avançar
      </Button>

      <Stack
        direction={"row"}
        justifyContent={"center"}
        alignItems={"center"}
        mt={2}
        mb={12}
        gap={1}
        sx={{
          cursor: "pointer",
        }}
      >
        <InfoIcon
          sx={{
            color: "#2894f7",
          }}
        />
        <Typography
          color="#2CABF9"
          fontWeight={600}
          fontSize={"15px"}
          sx={{
            zIndex: 1000,
          }}
          onClick={() => setOpenModalInfo(true)}
        >
          Encontrar meu código de cliente
        </Typography>
      </Stack>
      <ModalFindCode
        open={openModalInfo}
        onClose={() => setOpenModalInfo(false)}
      />
      <LinkCnpjSuccessModal
        open={openModalSuccess}
        name={name}
        cnpj={cnpj}
        onClose={() => {
          setOpenModalSuccess(false);
          router.push("/home");
        }}
      />
    </>
  );
}
